export default "__VITE_ASSET__DB124qpX__"